import { FronteggContext } from '@frontegg/rest-api';
import { AxiosIntegrations } from 'src/lib';
import { showToastError } from 'src/utilities/errortoast';

export const updateEncounterWithVimMappings = (payload) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await AxiosIntegrations.post(`/document_mapper`, payload, {
      headers,
    });
    if (result?.status === 200) {
      return result?.data;
    } else {
      showToastError('Failed to update encounter');
      return;
    }
  };
};
